import React from 'react'
import { SectionCard } from './SectionCard'
import { VIDEO_LABELS, normalizeVideoMetrics, activeVideoKeys } from './videoMetrics'
import type { DomainRow } from '../../../types/dashboard'

interface Props {
  rows: DomainRow[]
  sectionRef?: React.RefObject<HTMLDivElement>
}

export function DomainsSection({ rows, sectionRef }: Props) {
  const videoKeys = activeVideoKeys(rows.map(r => r.video_metrics))
  const totalCols = 6 + videoKeys.length

  return (
    <SectionCard title="Top 20 Domains" sectionRef={sectionRef} id="section-domains">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 dark:border-gray-700">
              <th className="text-left py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Domain</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Total Impressions</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Clicks</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">CTR %</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Engagement Rate %</th>
              <th className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">Engagement</th>
              {videoKeys.map(k => (
                <th key={k} className="text-right py-2 pr-4 text-gray-500 dark:text-gray-400 font-medium">{VIDEO_LABELS[k]}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => {
              const norm = normalizeVideoMetrics(row.video_metrics)
              return (
                <tr key={i} className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/40">
                  <td className="py-3 pr-4 font-medium text-gray-900 dark:text-white">{row.domain}</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.impressions.toLocaleString()}</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.clicks.toLocaleString()}</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.ctr.toFixed(2)}%</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.engagement_rate.toFixed(2)}%</td>
                  <td className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">{row.engagement.toLocaleString()}</td>
                  {videoKeys.map(k => {
                    const m = norm[k]
                    return (
                      <td key={k} className="py-3 pr-4 text-right text-gray-800 dark:text-gray-200">
                        {m && m.count > 0 ? `${m.count.toLocaleString()} (${m.pct.toFixed(2)}%)` : '—'}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
            {rows.length === 0 && (
              <tr>
                <td colSpan={totalCols} className="py-8 text-center text-gray-400">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </SectionCard>
  )
}
